import React from 'react'
import { DateTime } from 'luxon'
import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import { REMOVE_COACH_AVAILABILITY_OVERRIDE } from './queries'

const useStyles = makeStyles(theme => ({
  header: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}))

const CustomAvailabilityDestroyDialog = ({ override, onSuccess, trigger }) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()

  const formattedDate = DateTime.fromISO(override.date).toFormat('MMM dd, yyyy')
  const formattedSlots = override.timeSlots
    .map(ts => {
      const start = DateTime.fromISO(ts.startTime).toFormat('h:mma')
      const end = DateTime.fromISO(ts.endTime).toFormat('h:mma')
      return `${start} - ${end}`
    })
    .join(', ')

  const [removeOverride] = useMutation(REMOVE_COACH_AVAILABILITY_OVERRIDE)

  const handleRemoveOverride = closeDialog => {
    removeOverride({
      variables: { id: override.id },
      onCompleted: data => {
        if (data?.removeCoachAvailabilityOverride?.success) {
          enqueueSnackbar('Custom availability deleted', { variant: 'success' })
          onSuccess && onSuccess()
          closeDialog()
        } else {
          enqueueSnackbar(
            data?.removeCoachAvailabilityOverride?.message ||
              'Failed to delete custom availability',
            { variant: 'error' },
          )
        }
      },
      onError: () => {
        enqueueSnackbar(
          'Failed to delete custom availability. Please try again.',
          { variant: 'error' },
        )
      },
    })
  }

  return (
    <Dialog trigger={trigger} maxWidth="sm" fullWidth showCloseButton>
      {({ closeDialog }) => (
        <>
          <DialogTitle className={classes.header}>
            Delete custom availability?
          </DialogTitle>
          <DialogContent dividers>
            <Box py={2}>
              <Box textAlign="center" mb={2} fontWeight="fontWeightBold">
                {formattedDate}: {formattedSlots}
              </Box>

              <Box display="flex" mb={2}>
                <Typography>
                  Deleting this custom availability will revert to your general
                  availability for this date.
                </Typography>
              </Box>

              <Box display="flex" mb={2}>
                <Typography>Are you sure you want to delete it?</Typography>
              </Box>

              <Box display="flex" mt={4}>
                <Box mr={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => handleRemoveOverride(closeDialog)}
                  >
                    Confirm
                  </Button>
                </Box>
                <Button onClick={closeDialog} size="large">
                  Cancel
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default CustomAvailabilityDestroyDialog
